<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0">What forms of payment can I use?</h1>
			<p>{{ payments }}</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';
	import Axios from 'axios';

	export default {
		name: "FormsOfPayment",

		components: {
			BaseNavLinks,
		},
		data() {
			return {
				payments: ''
			}
		},
		mounted() {
			const self = this;
			Axios.get('/service/customer_help/rest/index.php/customer_help/get_payment_methods')
				.then(function (response) {
					self.payments = response['data']['data'];
				});
		},
	}
</script>

<style scoped>

</style>